<template>
    <Layout :style="`min-height: ${innerHeight}px`">
        <!-- logo -->
        <Header>
            <div class="layout_logo" v-if="diy_id == 0">
                <!-- <img src="@/assets/logo.png" /> -->
                <div class="theme-color">溯源系统</div>
                <Icon
                    class="cursor-pointer mr24 ml24"
                    :class="rotateIcon"
                    type="md-menu"
                    size="24"
                    @click="collapsedSider"
                ></Icon>
            </div>
            <div class="layout_nav" v-if="diy_id == 0">
                <div @click="goModal(1)">
                    <div class="nav_div" v-if="!news_count">
                        <img src="@/assets/notice.png" />
                    </div>
                    <div class="nav_div" v-else>
                        <img src="@/assets/notice-active.png" />
                        <div class="notice_position">
                            {{ news_count > 99 ? "99+" : news_count }}
                        </div>
                    </div>
                </div>
                <div class="nav_div">
                    <img
                        class="nav_portrait"
                        src="@/assets/head_portrait.png"
                        @click="goModal(2)"
                    />
                    <div class="nav_txt" @click="goModal(2)">{{ user }}</div>
                </div>
                <div class="nav_div" @click="goLogout">
                    <img class="wh24 mr12" src="@/assets/shutdown.png" />
                    <div>安全弹出</div>
                </div>
            </div>
        </Header>
        <!-- 动态菜单 -->
        <Layout>
            <Sider
                class="sider_div"
                :style="'height:' + (innerHeight - 64) + 'px;'"
                v-if="diy_id == 0"
                ref="sides"
                hide-trigger
                collapsible
                :collapsed-width="78"
                v-model="isCollapsed"
            >
                <Menu
                    :class="menuitemClasses"
                    :active-name="String($route.name)"
                    ref="menu"
                    theme="light"
                    width="auto"
                    :open-names="openNames"
                >
                    <div v-for="(item, index) in muen" :key="index">
                        <template v-if="item.children">
                            <Submenu v-if="!isCollapsed" :name="item.name">
                                <template slot="title">
                                    <div
                                        class="template_div"
                                        @mouseover="changeImage(item)"
                                        @mouseout="resetImage"
                                    >
                                        <img
                                            class="mr5"
                                            :src="currentImage(item)"
                                        />
                                        <span>{{ item.title }}</span>
                                    </div>
                                </template>
                                <MenuItem
                                    v-for="(child, i) in item.children"
                                    :key="i"
                                    :name="child.name"
                                    :to="child.path"
                                >
                                    <div>{{ child.title }}</div>
                                </MenuItem>
                            </Submenu>
                            <!-- collapsible -->
                            <Tooltip
                                v-else
                                placement="right"
                                theme="light"
                                transfer
                            >
                                <MenuItem :name="item.name">
                                    <img :src="item.icon" />
                                    <span>{{ item.title }}</span>
                                </MenuItem>
                                <div slot="content">
                                    <MenuItem
                                        v-for="(child, i) in item.children"
                                        :key="i"
                                        :name="child.name"
                                        :to="child.path"
                                        >{{ child.title }}</MenuItem
                                    >
                                </div>
                            </Tooltip>
                        </template>
                        <template v-else>
                            <MenuItem :name="item.name" :to="item.path">
                                <div
                                    class="template_div"
                                    @mouseover="changeImage(item)"
                                    @mouseout="resetImage"
                                >
                                    <img
                                        class="mr5"
                                        :src="currentImage(item)"
                                    />
                                    <span>{{ item.title }}</span>
                                </div>
                            </MenuItem>
                        </template>
                    </div>
                </Menu>
            </Sider>
            <!-- 页面主体 -->
            <Layout
                :style="'height:' + (innerHeight - 64) + 'px;padding: 24px'"
            >
                <!-- v-if -->
                <Breadcrumb
                    class="breadcrumb-title"
                    v-if="
                        $route.path != '/admin' &&
                        $route.path != '/admin/formwork/query' &&
                        $route.path != '/admin/formwork/editDiy' &&
                        $route.path != '/admin/verbuy' &&
                        $route.path != '/admin/assembly/mall'
                    "
                >
                    <BreadcrumbItem
                        v-for="(item, index) in $route.matched.slice(1)"
                        :key="index"
                    >
                        <span
                            class="cursor-pointer"
                            v-if="
                                item.meta.title == '应用组件' &&
                                $route.path != '/admin/assembly'
                            "
                            @click="goAssembly"
                            >应用组件</span
                        >
                        <span v-else>{{ item.meta.title }}</span>
                    </BreadcrumbItem>
                </Breadcrumb>
                <div
                    class="breadcrumb-title"
                    v-if="$route.path == '/admin/formwork/query'"
                >
                    <Breadcrumb>
                        <BreadcrumbItem
                            v-for="(item, index) in $route.matched.slice(1)"
                            :key="index"
                            >{{ item.meta.title }}</BreadcrumbItem
                        >
                    </Breadcrumb>
                    <div class="breadcrumb-tip">
                        入口链接：
                        <span
                            class="theme-color cursor-pointer"
                            @click="goCopy"
                            >{{ config.apiUrl + "/query?id=" + admin_id }}</span
                        >
                        <Icon
                            class="cursor-pointer"
                            type="md-copy"
                            color="#FF761D "
                            @click="goCopy"
                        />
                    </div>
                </div>
                <div
                    class="breadcrumb-title"
                    v-if="$route.path == '/admin/verbuy'"
                >
                    <Breadcrumb>
                        <BreadcrumbItem
                            v-for="(item, index) in $route.matched.slice(1)"
                            :key="index"
                            >{{ item.meta.title }}</BreadcrumbItem
                        >
                    </Breadcrumb>
                    <div class="breadcrumb-tip">
                        <template v-if="breadcrumb_data.name">
                            当前版本:
                            <span class="breadcrumb-tip-txt">{{
                                breadcrumb_data.name
                            }}</span>
                        </template>
                        <template v-if="breadcrumb_data.end_date">
                            截止日期:
                            <span class="breadcrumb-tip-txt">{{
                                breadcrumb_data.end_date
                            }}</span>
                        </template>
                        <template v-if="breadcrumb_data.qrcode_nums">
                            最大生码量:
                            <span class="breadcrumb-tip-txt">{{
                                breadcrumb_data.qrcode_nums
                            }}</span>
                        </template>
                        <template v-if="breadcrumb_data.remaining_nums">
                            可生码量:
                            <span class="breadcrumb-tip-txt">{{
                                breadcrumb_data.remaining_nums
                            }}</span>
                        </template>
                        <Button
                            class="theme-bc theme-default-color"
                            @click="goBuy"
                            >购买码包</Button
                        >
                    </div>
                </div>
                <div
                    class="breadcrumb-assembly"
                    v-if="$route.path == '/admin/assembly/mall'"
                >
                    <Breadcrumb>
                        <BreadcrumbItem
                            v-for="(item, index) in $route.matched.slice(1)"
                            :key="index"
                            >{{ item.meta.title }}</BreadcrumbItem
                        >
                    </Breadcrumb>
                    <div class="breadcrumb-mall">
                        <Menu
                            mode="horizontal"
                            :active-name="mall_value"
                            @on-select="saveMallValue"
                        >
                            <MenuItem name="1">积分商城</MenuItem>
                            <MenuItem name="2">积分订单</MenuItem>
                            <MenuItem name="3">banner设置</MenuItem>
                            <MenuItem name="4">积分设置</MenuItem>
                        </Menu>
                    </div>
                </div>
                <Content>
                    <!-- 子页面 -->
                    <router-view></router-view>
                </Content>
            </Layout>
        </Layout>

        <!-- 账户信息/防伪预警 -->
        <Modal v-model="modals" :width="modalWidth" :mask-closable="false">
            <div slot="header">
                <div class="header-container">{{ modalTitle }}</div>
            </div>
            <div>
                <template v-if="modalID == 1">
                    <div class="flex-sb">
                        <div class="mr24 modal-box">
                            <Select
                                class="w200 mr24 mb12"
                                v-model="storePramsModal.type"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in typeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                            <Select
                                class="w200 mr24 mb12"
                                v-model="storePramsModal.status"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in statusList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                            <Input
                                class="w200 mr24 mb12"
                                type="text"
                                v-model="storePramsModal.qrcode_number"
                                placeholder="请输入溯源码编码"
                            ></Input>
                            <DatePicker
                                class="w200 mr24 mb12"
                                type="daterange"
                                split-panels
                                placement="bottom-start"
                                placeholder="选择日期"
                                separator=" 至 "
                                @on-change="changeDate"
                            ></DatePicker>
                        </div>
                        <div class="modal-btn">
                            <Button class="mb12 read-all-btn" @click="goReadAll"
                                >标记所有为已读</Button
                            >
                            <Button
                                class="theme-bc ml24 mb12 search-btn theme-default-color"
                                icon="ios-search"
                                @click="goSearch"
                                >确认搜索</Button
                            >
                        </div>
                    </div>
                    <Table
                        ref="selection"
                        :columns="columnsModal"
                        :data="dataModal"
                        border
                        @on-selection-change="changeSelection"
                    >
                        <template slot-scope="{ row }" slot="title">
                            <div>{{ row.title }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="status">
                            <div class="theme-color" v-if="row.status == 1">
                                未读
                            </div>
                            <div v-else-if="row.status == 2">已读</div>
                        </template>
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <Button
                                    type="success"
                                    ghost
                                    @click="goModal(3, row)"
                                    >详情</Button
                                >
                                <Button
                                    type="error"
                                    ghost
                                    @click="goDel(1, row)"
                                    >删除</Button
                                >
                            </div>
                        </template>
                    </Table>
                    <div class="page_div">
                        <div>
                            <Checkbox
                                class="mr24 ml24"
                                v-model="del_value"
                                @on-change="handleSelectAll"
                                >全选</Checkbox
                            >
                            <Button type="error" ghost @click="goDel(0)"
                                >删除</Button
                            >
                        </div>
                        <Page
                            :current="storePramsModal.page"
                            :page-size="storePramsModal.limit"
                            :total="totalModal"
                            show-elevator
                            show-total
                            @on-change="pageChangeModal"
                        />
                    </div>
                </template>
                <template v-if="modalID == 2">
                    <Form
                        :model="formItem"
                        label-position="right"
                        :label-width="100"
                        :rules="ruleValidate"
                    >
                        <FormItem label="账户名称：" prop="user">
                            <Input
                                type="text"
                                v-model="formItem.user"
                                placeholder="请输入账户名称"
                            ></Input>
                        </FormItem>
                        <FormItem label="登录密码：">
                            <Input
                                type="password"
                                v-model="formItem.password"
                                placeholder="请输入登录密码"
                            ></Input>
                        </FormItem>
                        <FormItem label="手机号：" prop="phone">
                            <Input
                                type="text"
                                v-model="formItem.phone"
                                placeholder="请输入手机号"
                            ></Input>
                        </FormItem>
                    </Form>
                </template>
            </div>
            <div slot="footer">
                <template v-if="modalID == 2">
                    <Button @click="removeModal">取消修改</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitModal"
                        >确定修改</Button
                    >
                </template>
            </div>
        </Modal>
        <!-- 预警详情 -->
        <Modal v-model="info_modal" width="700" :mask-closable="false">
            <div slot="header">
                <div class="header-container">防窜货预警详情</div>
            </div>
            <div>
                <div>
                    <div class="detail_header">
                        <img
                            class="width_22 mr24"
                            src="@/assets/information.png"
                        />
                        <div>
                            预警原因：当前产品<span style="color: #fb5451"
                                >首次查询区域与指定代理（代理商）销售区域不一致</span
                            >，有相关窜货嫌疑，请核实
                        </div>
                    </div>
                    <div class="detail_content">
                        <div>
                            <div class="detail_div">
                                <div class="detail_left">产品名称:</div>
                                <div class="ta-l">
                                    {{ detailData.product_name }}
                                </div>
                            </div>
                            <div class="detail_div">
                                <div class="detail_left">产品规格:</div>
                                <div class="ta-l">{{ detailData.specs }}</div>
                            </div>
                            <div class="detail_div">
                                <div class="detail_left">关联溯源码编码:</div>
                                <div class="ta-l">
                                    {{ detailData.qrcode_number }}
                                </div>
                            </div>
                            <div class="detail_div">
                                <div class="detail_left">所属代理:</div>
                                <div class="ta-l">
                                    {{ detailData.agent_name }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="detail_div">
                                <div class="detail_left">所属批次:</div>
                                <div class="ta-l">{{ detailData.batch }}</div>
                            </div>
                            <div class="detail_div">
                                <div class="detail_left">商品ID:</div>
                                <div class="ta-l">{{ detailData.id }}</div>
                            </div>
                            <div class="detail_div">
                                <div class="detail_left">代理区域:</div>
                                <div class="ta-l">
                                    {{
                                        detailData.region[0]
                                            ? detailData.region[0].province
                                            : "-"
                                    }}{{
                                        detailData.region[0]
                                            ? detailData.region[0].city
                                            : "-"
                                    }}{{
                                        detailData.region[0]
                                            ? detailData.region[0].county
                                            : "-"
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Table :columns="columnsDetail" :data="dataDetail" border>
                    <template slot-scope="{ row }" slot="name">
                        <div class="flex-c">
                            <img
                                class="wh16 mr12"
                                v-if="row.drive == 'ios'"
                                src="@/assets/ios.png"
                            />
                            <img
                                class="wh16 mr12"
                                v-else
                                src="@/assets/android.png"
                            />
                            <div>{{ row.name }}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="province">
                        <div v-if="row.address">{{ row.address }}</div>
                        <div v-else>{{ row.province }}{{ row.city }}</div>
                    </template>
                </Table>
                <div class="mt24 ta-r">
                    <Page
                        :current="storePramsDetail.page"
                        :page-size="storePramsDetail.limit"
                        :total="totalDetail"
                        show-elevator
                        show-total
                        @on-change="pageChangeDetail"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 联系客服 -->
        <!-- <ContactButton
            v-if="$route.path != '/admin/formwork/editDiy'"
            :type="2"
        />
        <div v-if="tip_value" class="tip-container">
            <img
                src="@/assets/tips_path.png"
                class="tip-img"
                @click="openTips"
            />
            <img
                src="@/assets/pop_close.png"
                class="tips-icon"
                @click="closeTips"
            />
        </div> -->

        <!-- 购买码包 -->
        <Modal
            v-model="buy_modal"
            width="800"
            :closable="false"
            @on-cancel="cancelMoneyModal"
        >
            <div slot="header">
                <div class="buy-header">
                    <div class="buy-header-title">购买码包</div>
                    <div>当前剩余：{{ buy_data.qrcode_count }}</div>
                </div>
            </div>
            <div>
                <div class="buy-tip" @click="goRecord">
                    购买记录
                    <img src="@/assets/version/right.png" class="ml6" />
                </div>
                <div class="flex-bs">
                    <div class="buy-left">
                        <div
                            v-for="(item, index) in buy_list"
                            :key="index"
                            :class="
                                active_buy_value == index
                                    ? 'buy-card-active'
                                    : 'buy-card'
                            "
                            @click="activeBuy(item, index)"
                        >
                            <div v-if="item.ori_price" class="buy-card-icon">
                                {{ item.ori_price }}
                            </div>
                            <div>{{ item.nums }}个</div>
                            <div class="buy-price">￥{{ item.price }}</div>
                        </div>
                    </div>
                    <div v-if="active_buy_value > -1" class="buy-container">
                        <div class="money-card2-title">支付方式</div>
                        <div class="money-img-container">
                            <img
                                v-if="loading"
                                src="@/assets/loading.gif"
                                alt="加载中"
                                class="loading-img-container"
                            />
                            <VueQr
                                v-else-if="buy_data.data"
                                id="vueQr"
                                :text="buy_data.data"
                            ></VueQr>
                        </div>
                        <div class="money-right">
                            <div class="money-right-title">在线支付</div>
                            <div class="money-right-btn-div">
                                <!-- <div :class="buy_value == 2 ? 'money-right-btn-active2' : 'money-right-btn'" @click="changeBuy(2)">
                                    <img v-if="buy_value == 2" src="@/assets/version/alipay-active.png" class="money-right-img">
                                    <img v-else src="@/assets/version/alipay.png" class="money-right-img">
                                    <div>支付宝支付</div>
                                </div>
                                <div> | </div> -->
                                <div
                                    :class="
                                        buy_value == 1
                                            ? 'money-right-btn-active1'
                                            : 'money-right-btn'
                                    "
                                    @click="changeBuy(1)"
                                >
                                    <img
                                        v-if="buy_value == 1"
                                        src="@/assets/version/wechat-active.png"
                                        class="money-right-img"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/version/wechat.png"
                                        class="money-right-img"
                                    />
                                    <div>微信支付</div>
                                </div>
                            </div>
                            <div>应支付金额</div>
                            <div class="money-p-div">
                                <div class="money-p">
                                    ￥{{ buy_data.price }}
                                </div>
                                <div
                                    v-if="buy_data.original_price"
                                    class="money-span"
                                >
                                    原价￥{{ buy_data.original_price }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="buy-none"></div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 购买记录 -->
        <Modal v-model="record_modal" width="700">
            <div slot="header">
                <div class="header-container">购买记录</div>
            </div>
            <div>
                <Table :columns="columnsTable" :data="dataTable" border></Table>
                <div class="mt24 ta-r">
                    <Page
                        :current="storePrams.page"
                        :page-size="storePrams.limit"
                        :total="total"
                        show-elevator
                        show-total
                        @on-change="pageChange"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
    </Layout>
</template>

<script>
import {
    logout,
    home_news_list,
    home_delete_info,
    home_news_info,
    other_citys,
    home_news_count,
    account_modify_info,
    home_read_all,
    version_qrcode,
    version_qrcode_buy,
    version_order,
    version_query,
    account_version,
} from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { removeCookies } from "@/utils/helper";
import ContactButton from "@/components/ContactButton/ContactButton.vue";
import VueQr from "vue-qr";
export default {
    components: { ContactButton, VueQr },
    data() {
        return {
            imageValue: "",
            innerHeight: 0,
            diy_id: 0,
            user: "",
            phone: "",
            id: "",
            admin_id: "",
            openNames: [],
            news_count: 0, //未读总数
            modals: false,
            info_modal: false,
            formItem: {
                user: "",
                password: "",
                phone: "",
            },
            isCollapsed: false,
            modalTitle: "",
            modalID: "",
            modalWidth: "",
            storePramsModal: {
                page: 1,
                limit: 10,
                start_date: "",
                end_date: "",
                type: "",
                status: "",
                qrcode_number: "",
            },
            totalModal: 0,
            columnsModal: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "消息内容", key: "content", align: "center" },
                { title: "消息类型", slot: "title", align: "center" },
                {
                    title: "关联溯源码编码",
                    key: "qrcode_number",
                    align: "center",
                },
                { title: "时间", key: "handle_time", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "170px",
                },
            ],
            dataModal: [],
            typeList: [
                { id: -1, name: "全部" },
                { id: 1, name: "防伪预警" },
                { id: 2, name: "防窜货预警" },
            ],
            statusList: [
                { id: -1, name: "全部" },
                { id: 1, name: "未读" },
                { id: 2, name: "已读" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            storePramsDetail: {
                page: 1,
                limit: 10,
                id: "",
            },
            totalDetail: 0,
            columnsDetail: [
                { type: "index", width: 60, align: "center" },
                {
                    title: "查询次数",
                    key: "product_query_count",
                    align: "center",
                },
                { title: "查询时间", key: "created_at", align: "center" },
                { title: "查询会员", slot: "name", align: "center" },
                {
                    title: "查询人员定位信息",
                    slot: "province",
                    align: "center",
                },
                { title: "IP", key: "ip", align: "center" },
            ],
            dataDetail: [],
            detailData: {
                product_name: "",
                batch: "",
                specs: "",
                id: "",
                qrcode_number: "",
                count: "",
                agent_name: "",
                region: [],
            },
            ruleValidate: {
                user: [
                    {
                        required: false,
                        message: "请输入账户名称",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: false,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                ],
            },
            tip_value: false,
            breadcrumb_data: {
                name: "",
                qrcode_nums: "",
                remaining_nums: "",
                end_date: "",
            },
            buy_modal: false,
            loading: false,
            buy_value: 1,
            buy_data: {
                qrcode_count: 0,
                id: "",
                data: "",
                price: "",
                original_price: "",
                order_id: "",
            },
            buy_list: [],
            active_buy_value: -1,
            record_modal: false,
            storePramsRecord: {
                page: 1,
                limit: 10,
            },
            totalRecord: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "码数量", key: "qrcode_nums", align: "center" },
                { title: "金额", key: "price", align: "center" },
                { title: "时间", key: "created_at", align: "center" },
            ],
            dataTable: [],
            storePrams: {
                page: 1,
                limit: 30,
                type: 2,
            },
            total: 0,
            mall_value: "1",
        };
    },
    metaInfo: {
        title: "首页",
        meta: [
            {
                name: "viewport",
                content:
                    "width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2",
            },
        ],
    },
    computed: {
        muen() {
            return this.$store.state.menus;
        },
        rotateIcon() {
            return ["menu_icon", this.isCollapsed ? "rotate_icon" : ""];
        },
        menuitemClasses() {
            return ["menu_item", this.isCollapsed ? "collapsed_menu" : ""];
        },
    },
    created() {
        this.user = localStorage.getItem("user");
        this.phone = localStorage.getItem("phone");
        this.id = localStorage.getItem("id");
        this.admin_id = localStorage.getItem("admin_id");
        if (!localStorage.getItem("cityList")) {
            this.getCity();
        }
        if (localStorage.getItem("tips_path")) {
            this.tip_value = true;
        }
    },
    mounted() {
        this.getAccountVersion();
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.selectMenu();
        this.getNewsCount();
    },
    watch: {
        "$route.path"() {
            this.selectMenu();
        },
        $route: {
            handler(to, from) {
                if (to.path === "/admin/verbuy") {
                    this.getAccountVersion();
                }
            },
            immediate: true,
        },
        mall_value(newVal) {
            this.$bus.$emit("mallValueChange", newVal);
        },
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearInterval();
    },
    methods: {
        getAccountVersion() {
            account_version().then((res) => {
                this.breadcrumb_data.name = res.data.name;
                this.breadcrumb_data.qrcode_nums = res.data.qrcode_nums;
                this.breadcrumb_data.remaining_nums = res.data.remaining_nums;
                this.breadcrumb_data.end_date = res.data.end_date;
            });
        },
        currentImage(item) {
            // 确保返回的是图片的URL
            if (this.imageValue == item.name) {
                return item.select_icon;
            } else {
                return item.name == this.$route.name
                    ? item.select_icon
                    : item.icon;
            }
        },
        changeImage(item) {
            this.imageValue = item.name;
        },
        resetImage() {
            this.imageValue = "";
        },
        // 获取预警信息未读总数
        getNewsCount() {
            home_news_count()
                .then((res) => {
                    this.news_count = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getCity() {
            other_citys().then((res) => {
                localStorage.setItem("cityList", JSON.stringify(res.data));
            });
        },
        getList() {
            home_news_list(this.storePramsModal)
                .then((res) => {
                    this.dataModal = res.data.data;
                    this.totalModal = res.data.total;
                    // 删除后，page--
                    if (
                        !res.data.data.length &&
                        this.storePramsModal.page != 1
                    ) {
                        this.storePramsModal.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goSearch() {
            this.storePramsModal.page = 1;
            this.getList();
        },
        pageChangeModal(index) {
            this.storePramsModal.page = index;
            this.getList();
        },
        pageChangeDetail(index) {
            this.storePramsDetail.page = index;
            this.getNewsInfo();
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getVersionOrder();
        },
        changeDate(e) {
            if (e[0]) {
                this.storePramsModal.start_date = e[0];
                this.storePramsModal.end_date = e[1];
            } else {
                this.storePramsModal.start_date = "";
                this.storePramsModal.end_date = "";
            }
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "是否确认删除防伪预警消息，删除后将无法恢复！",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        home_delete_info({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        home_delete_info({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        collapsedSider() {
            this.$refs.sides.toggleCollapse();
        },
        /**修改高度 */
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        /**修改导航展开样式 */
        selectMenu() {
            // DIY导航展开关闭
            if (this.$route.query.diy_id) {
                this.diy_id = this.$route.query.diy_id;
            } else {
                this.diy_id = 0;
                this.openNames = [this.$route.name.split("-")[0]];
                this.$nextTick(() => {
                    this.$refs.menu.updateOpened();
                });
            }
        },
        goLogout() {
            logout()
                .then((res) => {
                    this.$Message.success(res.msg);
                    localStorage.clear();
                    removeCookies("pcToken");
                    this.$router.push({ path: "/" });
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goModal(index, row) {
            if (index == 1) {
                this.modalID = index;
                this.modalTitle = "防伪预警";
                this.modalWidth = "80";
                this.getList();
                setTimeout(() => {
                    this.modals = true;
                }, 300);
            } else if (index == 2) {
                this.modalID = index;
                this.modalTitle = "账户信息";
                this.modalWidth = "500";
                this.formItem.user = this.user;
                this.formItem.phone = this.phone;
                this.modals = true;
            } else if (index == 3) {
                this.storePramsDetail.id = row.id;
                this.getNewsInfo();
                setTimeout(() => {
                    this.info_modal = true;
                    if (row.status == 1) {
                        this.getList();
                        this.getNewsCount();
                    }
                }, 300);
            }
        },
        getNewsInfo() {
            home_news_info(this.storePramsDetail)
                .then((res) => {
                    this.dataDetail = res.data.list.data;
                    this.totalDetail = res.data.list.total;
                    this.detailData.product_name = res.data.infos.qrcode.product
                        ? res.data.infos.qrcode.product.product_name
                        : "";
                    this.detailData.batch =
                        res.data.infos.qrcode.batch.batch_name;
                    this.detailData.specs = res.data.infos.qrcode.product
                        ? res.data.infos.qrcode.product.specs
                        : "";
                    this.detailData.id = res.data.infos.qrcode.product
                        ? res.data.infos.qrcode.product.id
                        : "";
                    this.detailData.qrcode_number =
                        res.data.infos.qrcode.qrcode_number;
                    this.detailData.count = "";
                    this.detailData.agent_name = res.data.infos.qrcode.agent
                        ? res.data.infos.qrcode.agent.agent_name
                        : "";
                    this.detailData.region = res.data.infos.qrcode.agent
                        ? res.data.infos.qrcode.agent.region
                        : "";
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        removeModal() {
            this.modals = false;
        },
        submitModal() {
            account_modify_info(this.formItem)
                .then((res) => {
                    this.modals = false;
                    this.goLogout();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goCopy() {
            let text = this.config.apiUrl + "/query?id=" + this.admin_id;
            this.$copyText(text).then(
                (e) => {
                    this.$Message.success({
                        background: true,
                        content: "复制成功",
                        closable: true,
                    });
                },
                (err) => {
                    alert("复制失败");
                    console.log(err);
                }
            );
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataModal.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataModal;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        // 跳转应用组件
        goAssembly() {
            this.$router.push({ path: "/admin/assembly" });
        },
        goReadAll() {
            home_read_all()
                .then((res) => {
                    this.getList();
                    this.getNewsCount();
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        closeTips() {
            localStorage.removeItem("tips_path");
            this.tip_value = false;
        },
        openTips() {
            localStorage.removeItem("tips_path");
            window.open(localStorage.getItem("tips_link"));
        },
        goBuy() {
            this.loading = true;
            this.getVersionQrcode();
            setTimeout(() => {
                this.buy_modal = true;
            }, 300);
        },
        getVersionQrcode() {
            version_qrcode()
                .then((res) => {
                    this.buy_list = res.data.list;
                    this.buy_data.qrcode_count = res.data.qrcode_count;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeBuy(i) {
            this.buy_value = i;
            this.clearInterval();
            this.getVersionQrcode();
        },
        cancelMoneyModal() {
            this.active_buy_value = -1;
            this.clearInterval();
        },
        activeBuy(item, index) {
            this.buy_data.id = item.id;
            this.getVersionQrcodeBuy();
            setTimeout(() => {
                this.active_buy_value = index;
            }, 300);
        },
        getVersionQrcodeBuy() {
            var data = {
                version_id: this.buy_data.id,
                pay_type: 1,
            };
            version_qrcode_buy(data)
                .then((res) => {
                    // 0元购
                    if (res.data && res.data.code && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                        return;
                    }
                    this.buy_data.data = res.data.data;
                    this.buy_data.price = res.data.price;
                    this.buy_data.original_price = res.data.original_price;
                    this.buy_data.order_id = res.data.order_id;
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                    this.startInterval();
                })
                .catch((err) => {
                    this.qrcode_data = "";
                    this.$Message.error(err.msg);
                });
        },
        goVersionQuery() {
            version_query({ order_id: this.buy_data.order_id }).then((res) => {
                // 0 未付款 1 付款成功
                if (res.data == 1) {
                    this.$Message.success("支付成功");
                    this.active_buy_value = -1;
                    this.clearInterval();
                    this.getAccountVersion();
                    setTimeout(() => {
                        this.buy_modal = false;
                    }, 300);
                }
            });
        },
        // 启动定时器
        startInterval() {
            this.timer = setInterval(() => {
                this.goVersionQuery();
            }, 5000);
        },
        // 清除定时器
        clearInterval() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        goRecord() {
            this.getVersionOrder();
            setTimeout(() => {
                this.record_modal = true;
            }, 300);
        },
        getVersionOrder() {
            version_order(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        saveMallValue(name) {
            this.mall_value = name;
        },
    },
};
</script>

<style scoped>
.wh16 {
    width: 16px;
    height: 16px;
}
.detail_header {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
}
.width_22 {
    width: 22px;
    height: 22px;
}
.detail_content {
    margin: 24px 0;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
}
.detail_div {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.detail_left {
    margin-right: 24px;
    width: 110px;
    text-align: right;
}
.page_div {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.sider_div {
    border-top: 1px solid #fff;
    margin: -1px 0 0 0;
    background: #fff;
    overflow: auto;
    scrollbar-width: none; /* 针对Firefox */
}
.sider_div::-webkit-scrollbar {
    display: none; /* 针对Chrome, Safari和Opera等Webkit浏览器 */
}
.menu_icon {
    transition: all 0.3s;
}
.rotate_icon {
    transform: rotate(-90deg);
}
.menu_item span {
    display: inline-block;
    overflow: hidden;
    width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width 0.2s ease 0.2s;
}
.menu_item i {
    transform: translateX(0px);
    transition: font-size 0.2s ease, transform 0.2s ease;
    vertical-align: middle;
    font-size: 16px;
}
.collapsed_menu span {
    width: 0px;
    transition: width 0.2s ease;
}
.collapsed_menu i {
    transform: translateX(5px);
    transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
    vertical-align: middle;
    font-size: 22px;
}
.wh24 {
    width: 24px;
    height: 24px;
}
.nav_portrait {
    margin-left: 36px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
.nav_txt {
    margin: 0 12px;
    padding-right: 24px;
    height: 20px;
    line-height: 20px;
}
.nav_div {
    display: flex;
    align-items: center;
    position: relative;
}
.layout_logo {
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
}
.layout_nav {
    float: right;
    display: flex;
    align-items: center;
    color: #484e66;
    cursor: pointer;
}
.notice_position {
    position: absolute;
    top: -10px;
    right: -22px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    background: #ff6161;
    border-radius: 50%;
    overflow: hidden;
    white-space: nowrap;
}
.breadcrumb-title {
    margin-bottom: 24px;
    padding: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.breadcrumb-title:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #ff761d;
    border-radius: 5px;
    margin-right: 5px;
}
.breadcrumb-tip {
    flex: 1;
    text-align: right;
}
.breadcrumb-tip-txt {
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-size: 14px;
    color: #ff761d;
    margin-right: 10px;
}
.breadcrumb-mall {
    flex: 1;
    text-align: center;
}
.ivu-layout-header {
    padding: 0 24px;
    background-color: #fff;
    position: relative;
    z-index: 99;
}
.ivu-layout-header:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #dcdee2;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #ff761d;
    color: #ff761d;
}
.ivu-menu-light {
    background-color: #fff;
    color: #333333;
    padding: 5px;
}
.ivu-menu-item {
    color: #333333;
}
.ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: none;
}
.ivu-menu-item:hover {
    color: #ff761d !important;
}

.template_div {
    display: flex;
    align-items: center;
    height: 22px;
    line-height: 22px;
}
.mr5 {
    margin: 0 5px 0 0;
}
.modal-box {
    padding-bottom: 0 !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.modal-btn {
    display: flex;
    flex-direction: row; /* 默认水平排列 */
}
.ta-r {
    text-align: right;
}
.ta-l {
    text-align: left;
}
.tip-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.tip-img {
    width: 700px;
    height: 400px;
    cursor: pointer;
}
.tips-icon {
    width: 32px;
    height: 32px;
    margin-top: -400px;
    cursor: pointer;
}
.cursor-pointer {
    cursor: pointer;
}
.buy-header {
    padding: 14px 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #fff;
    background: #ff761d;
    border-radius: 6px 6px 0 0;
}
.buy-header-title {
    font-size: 16px;
    margin-bottom: 10px;
}

.buy-tip {
    margin-bottom: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ff761d;
    cursor: pointer;
}

.ml6 {
    margin-left: 6px;
}

.flex-bs {
    display: flex;
    justify-content: space-between;
}

.buy-container {
    margin-left: 24px;
    min-width: 300px;
    width: 300px;
    background: #f9fef9;
    border-radius: 10px;
    border: 1px solid #d2d5e0;
    padding: 20px 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.buy-none {
    margin-left: 24px;
    min-width: 300px;
    width: 300px;
}

.money-card2-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
    margin-bottom: 20px;
}

.money-img-container {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
}
.loading-img-container {
    width: 50px;
    height: 50px;
}

.money-right {
    margin-top: 20px;
    width: 100%;
}
.money-right-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
    margin-bottom: 10px;
}
.money-right-btn-div {
    padding: 3px;
    border-radius: 4px;
    border: 1px solid #d2d5e0;
    width: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}
.money-right-btn {
    background: #e6e6e6;
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #afafaf;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-right-btn-active2 {
    background: rgba(125, 188, 253, 0.4);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #0680ff;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-right-btn-active1 {
    background: rgba(69, 204, 81, 0.24);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #27b133;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-p-div {
    display: flex;
    align-items: center;
    margin-top: 3px;
}

.money-p {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #de0000;
}
.money-span {
    margin-left: 24px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-size: 14px;
    color: #999999;
    text-decoration: line-through;
}

.buy-left {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.buy-card {
    margin-bottom: 24px;
    width: 210px;
    height: 120px;
    background: rgba(255, 255, 255, 0.09);
    border-radius: 10px;
    border: 1px solid #d2d5e0;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.buy-card-active {
    margin-bottom: 24px;
    width: 210px;
    height: 120px;
    background: linear-gradient(0deg, #f8d9c4 0%, #ffffff 100%);
    border-radius: 10px;
    border: 1px solid #ff761d;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.buy-card-icon {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 10px;
    width: 71px;
    height: 22px;
    background: url("../../assets/version/card-icon.png") no-repeat center
        center;
    background-size: 100% 100%;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-decoration-line: line-through;
}
.buy-price {
    margin-top: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #010101;
}

.header-container {
    padding: 14px 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
    background: #fff;
    border-radius: 6px 6px 0 0;
}

@media (max-width: 1300px) {
    .modal-btn {
        flex-direction: column; /* 垂直排列 */
    }
    .read-all-btn {
        order: 2; /* 显示在下 */
    }
    .search-btn {
        order: 1; /* 显示在上 */
    }
}
::v-deep .ivu-modal-header {
    padding: 0px;
}
::v-deep .layout_logo .ivu-select-selection {
    border: none;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #ff761d !important;
}
.breadcrumb-assembly {
    margin-bottom: 24px;
    padding: 0 24px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.breadcrumb-assembly:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #ff761d;
    border-radius: 5px;
    margin-right: 5px;
}
.breadcrumb-assembly ::v-deep .ivu-menu-horizontal.ivu-menu-light:after {
    background-color: #fff;
}
.breadcrumb-assembly ::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: center;
}
.breadcrumb-assembly ::v-deep .ivu-menu-item:hover {
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
.breadcrumb-assembly
    ::v-deep
    .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #ff761d;
    border-bottom: 2px solid #ff761d !important;
}
.breadcrumb-assembly ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
</style>